document.addEventListener('DOMContentLoaded', () => {
  const normalizeColor = (text) =>
    text
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim()
      .replace(/\s+/g, '-');

  function getSelectedColor() {
    const controls = document.querySelectorAll(
      'variant-selects select, variant-selects input:checked, variant-radios select, variant-radios input:checked, product-info select, product-info input:checked'
    );

    for (const control of controls) {
      const fieldset = control.closest('fieldset');
      const legend = fieldset?.querySelector('legend')?.textContent || '';
      const label =
        document.querySelector(`label[for="${control.id}"]`)?.textContent || '';
      const optionName = `${control.name || ''} ${legend} ${label}`.toLowerCase();

      if (
        optionName.includes('couleur') ||
        optionName.includes('color')
      ) {
        return normalizeColor(control.value);
      }
    }

    return null;
  }

  function filterVariantMedia() {
    const selectedColor = getSelectedColor();
    if (!selectedColor) return;

    const galleries = document.querySelectorAll('media-gallery');

    galleries.forEach((gallery) => {
      const mediaItems = gallery.querySelectorAll('[data-media-id]');

      mediaItems.forEach((item) => {
        const image = item.querySelector('img');
        if (!image) return;

        const alt = normalizeColor(image.alt || '');
        const isColorMedia = alt.includes('couleur-');

        if (!isColorMedia) {
          item.hidden = false;
          return;
        }

        item.hidden = !alt.includes(`couleur-${selectedColor}`);
      });

      const firstVisibleMedia = gallery.querySelector(
        '.product__media-item:not([hidden])'
      );

      if (
        firstVisibleMedia &&
        typeof gallery.setActiveMedia === 'function'
      ) {
        gallery.setActiveMedia(
          firstVisibleMedia.dataset.mediaId,
          false
        );
      }
    });
  }

  document.addEventListener('change', (event) => {
    if (
      event.target.matches(
        'variant-selects select, variant-selects input, variant-radios select, variant-radios input, product-info select, product-info input'
      )
    ) {
      setTimeout(filterVariantMedia, 150);
    }
  });

  setTimeout(filterVariantMedia, 300);
});